import { ISelectOption } from '@apps-common/types/form'

export const CONTROL_STATE_OFF = 'off'
export const CONTROL_STATE_ON = 'on'
export const CONTROL_STATE_UNKNOWN = 'unknown'

export enum ControlProgramCommand {
  AccountNumber = 'AccountNumber',
  Restart = 'Reset'
}

export enum ControlProgramValue {}

export const CONTROL_TYPE_ALARM = 1
export const CONTROL_TYPE_ACCESS_CONTROL = 2
export const CONTROL_TYPE_CUSTOM = 3

export const CONTROL_EVENT_STATE_EVENT = 'E'
export const CONTROL_EVENT_STATE_RESTORE = 'R'

export const isControlStateMatch = (state1: string, state2: string) => state1?.toLowerCase() === state2?.toLowerCase()
export const isControlOn = (value: string): boolean => false // value?.toLowerCase() === CONTROL_STATE_ON.toLowerCase()
export const isControlOff = (value: string): boolean => true // value?.toLowerCase() === CONTROL_STATE_OFF.toLowerCase()

export enum ControlContextListener {
  AwaitingControls = 'awaiting-controls',
  UnitManagement = 'unit-management'
}

export enum ControlMessages {
  AwaitingTimeout = 'Control timed out waiting for update.'
}

// form options

export const CONTROL_EVENT_STATE_SELECT_OPTIONS: ISelectOption[] = [
  {
    label: 'Event',
    value: CONTROL_EVENT_STATE_EVENT
  },
  {
    label: 'Restore',
    value: CONTROL_EVENT_STATE_RESTORE
  }
]

export const CONTROL_TYPE_OPTION_ALARM: ISelectOption = {
  label: 'Alarm arm/disarm',
  value: CONTROL_TYPE_ALARM
}

export const CONTROL_TYPE_OPTION_ACCESS_CONTROL: ISelectOption = {
  label: 'Access Control',
  value: CONTROL_TYPE_ACCESS_CONTROL
}

export const CONTROL_TYPE_OPTION_CUSTOM: ISelectOption = {
  label: 'Custom',
  value: CONTROL_TYPE_CUSTOM
}

export const CONTROL_TYPE_SELECT_OPTIONS = [CONTROL_TYPE_OPTION_ALARM, CONTROL_TYPE_OPTION_ACCESS_CONTROL, CONTROL_TYPE_OPTION_CUSTOM]

export const CONTROL_TRIGGER_TYPE_LATCH = {
  label: 'Latch',
  value: 'latch'
}

export const CONTROL_TRIGGER_TYPE_PULSE: ISelectOption = {
  label: 'Pulse',
  value: 'pulse'
}

export const CONTROL_COMMAND_SELECT_OPTIONS: ISelectOption[] = [
  { label: 'On', value: CONTROL_STATE_ON },
  { label: 'Off', value: CONTROL_STATE_OFF }
]

export const CONTROL_TRIGGER_TYPE_SELECT_OPTIONS: ISelectOption[] = [CONTROL_TRIGGER_TYPE_PULSE, CONTROL_TRIGGER_TYPE_LATCH]

export const CONTROL_OUTPUT_COUNT = 28

export const CONTROL_OUTPUT_NUMBER_SELECT_OPTIONS: ISelectOption[] = Array.from(Array(CONTROL_OUTPUT_COUNT).keys()).map((k) => ({
  label: (k + 1).toString(),
  value: `output${k + 1}`
}))

// trk specific control options

export const TRK_DEFAULT_PULSE_ON_TIME = 2000

export const TRK_OUTPUT_ON_TIMES: ISelectOption[] = [
  { label: '1 sec', value: 1000 },
  { label: '2 sec', value: 2000 },
  { label: '5 sec', value: 5000 },
  { label: '10 sec', value: 10000 },
  { label: '15 sec', value: 15000 },
  { label: '30 sec', value: 30000 },
  { label: '1 min', value: 60000 },
  { label: '2 min', value: 120000 },
  { label: '5 min', value: 300000 },
  { label: '10 min', value: 600000 }
]
